<div class="note-bg">
  <h5>Note:</h5>
  <ul class="p-0 m-0 list-point">
    <li><b>•</b> Cost components based on 2021 IPEDS data.</li>
    <li><b>•</b> All amounts are rounded up to the nearest 100.</li>
    <li>
      <b>•</b> Estimated grants and scholarships may not equal to the sum of all
      listed awards due to overlaps or other institutional eligibility rules.
    </li>
    <li>
      <b>•</b> Based on the students state they will be eligible for state
      grants.
    </li>
    <li>
      <b>•</b> Colleges Costs and Scholarships are shown on an annual basis.
    </li>

    <!-- <li class="col-md-7 text-right" >*Cost components based on 2021 IPEDS data</span</li> -->
  </ul>

  <div class="mt-2">
    <span class="note-source">Sources:</span>
    <ul>
      <li><b>1</b>. U.S. News Best Colleges Rankings.</li>

      
     
      <li>
        <b>2</b>. Georgetown University Center on Education and the Workforce.
      </li>
      <li>
        <b>3</b>.
        <a
          target="_blank"
          href="https://freopp.org/is-college-worth-it-a-comprehensive-return-on-investment-analysis-1b2ad17f84c8%22>"
          >Freopp.org</a
        >: Is College Worth It? A Comprehensive Return on Investment Analysis.
      </li>
    </ul>
  </div>

  <div class="text-center pt-3">
    <a class="btn page-btn" (click)="close()">Close</a>
  </div>
</div>
